export default __webpack_public_path__ + "static/media/titleicon1.dc715154.svg";